import {
  UploadImage,
  UploadImageRequest,
  UploadImageFromJSON
} from '@/api/models'
import * as runtime from '@/api/runtime'
import { HTTPHeaders } from '@/api/runtime'

export class UploadApi extends runtime.BaseAPI {
  async image(requestParameters: UploadImageRequest): Promise<UploadImage> {
    const headerParameters: HTTPHeaders = {}
    const response = await this.request({
      path: `/upload/image`,
      method: 'POST',
      headers: headerParameters,
      body: requestParameters.data
    })

    return new runtime.JSONApiResponse(response, jsonValue =>
      UploadImageFromJSON(jsonValue)
    ).value()
  }
}
